export default "__VITE_ASSET__Brfr5wES__"